import React, { Component } from "react";

class NotFound extends Component {
	render() {
		return <h1 className="error">404 error, you lost bro?</h1>;
	}
}

export default NotFound;
